module.exports = __webpack_public_path__ + "img/quest_icon_0049_air.48b38de1.png";